var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { attrs: { id: "section-training" } },
    [
      _c(_setup.MainSectionPanel, [
        _c(
          "div",
          {
            class: [
              "d-flex",
              "align-items-center",
              { "w-100": _setup.isMobile },
            ],
          },
          [
            _c(_setup.FeatureDetailsBlock, {
              attrs: {
                title: "Multi-Disciplinary Training Scenarios",
                details:
                  "Zephyr provides a variety of environments and multi-disciplinary training modules to grow skills for any level of operator or industry setting.",
                justification: "left",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        !_setup.isMobile
          ? _c(
              "div",
              { staticClass: "feature-roulette-container" },
              [
                _c(_setup.FeatureRoulette, {
                  attrs: { items: _setup.rouletteGroups.drones },
                }),
                _vm._v(" "),
                _c(_setup.FeatureRoulette, {
                  attrs: {
                    items: _setup.rouletteGroups.scenarios,
                    direction: "up",
                  },
                }),
                _vm._v(" "),
                _c(_setup.FeatureRoulette, {
                  attrs: { items: _setup.rouletteGroups.weather },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }